import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "o-form-login" }
const _hoisted_2 = {
  role: "group",
  class: "mb-6",
  "aria-labelledby": "username-label"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  id: "username-label",
  for: "username",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Username "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-sm text-red-500 font-semibold",
    "aria-label": "required"
  }, "*")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "username-help",
  class: "sr-only"
}, " Masukkan username Anda untuk melanjutkan proses login ", -1)
const _hoisted_5 = { class: "text-xs text-red-500 font-normal" }
const _hoisted_6 = {
  key: 0,
  class: "text-xs text-red-500 font-normal"
}
const _hoisted_7 = {
  role: "group",
  class: "mb-6",
  "aria-labelledby": "password-label"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  id: "password-label",
  for: "password",
  class: "text-sm text-primary-gc font-semibold mb-2"
}, [
  /*#__PURE__*/_createTextVNode(" Kata sandi "),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text-sm text-red-500 font-semibold",
    "aria-label": "required"
  }, "*")
], -1)
const _hoisted_9 = ["aria-label", "aria-pressed"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  id: "password-help",
  class: "sr-only"
}, " Masukkan kata sandi Anda. Gunakan tombol mata untuk menampilkan atau menyembunyikan kata sandi ", -1)
const _hoisted_11 = { class: "text-xs text-red-500 font-normal" }
const _hoisted_12 = {
  key: 0,
  class: "sr-only"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_BInputGroup = _resolveComponent("BInputGroup")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_BInputGroupText = _resolveComponent("BInputGroupText")!
  const _component_BButton = _resolveComponent("BButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "o-form-login__content",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
      onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleEnterKey && _ctx.handleEnterKey(...args)), ["enter"])),
      role: "form",
      "aria-labelledby": "login-heading"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_BInputGroup, null, {
          default: _withCtx(() => [
            _createVNode(_component_BFormInput, {
              modelValue: _ctx.formData.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.username) = $event)),
              state: _ctx.v$.username.$errors.length === 0 ? null : false,
              id: "username",
              type: "text",
              class: "placeholder-placeholder-gc",
              placeholder: "Masukkan username anda",
              required: "",
              autocomplete: "username",
              "aria-describedby": "username-errors username-help",
              "aria-invalid": _ctx.v$.username.$errors.length > 0,
              onInput: _ctx.v$.username.$touch,
              onKeydown: _withKeys(_ctx.handleEnterKey, ["enter"])
            }, null, 8, ["modelValue", "state", "aria-invalid", "onInput", "onKeydown"])
          ]),
          _: 1
        }),
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.username.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "username-errors",
            class: "input-errors",
            role: "alert",
            "aria-live": "polite",
            key: error.$uid
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(error.$message), 1)
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.error.email, (err, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "input-errors",
            role: "alert",
            "aria-live": "polite",
            key: index
          }, [
            err
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(err), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_BInputGroup, null, {
          append: _withCtx(() => [
            _createVNode(_component_BInputGroupText, { class: "border-l-0 bg-transparent" }, {
              default: _withCtx(() => [
                _createElementVNode("button", {
                  type: "button",
                  id: "password-visibility-toggle",
                  class: "cursor-pointer text-placeholder-gc bg-transparent border-0 p-0 focus:outline-none focus:ring-2 focus:ring-primary-gc focus:ring-offset-1",
                  "aria-label": 
                  _ctx.isShowPassword
                    ? 'Tampilkan kata sandi'
                    : 'Sembunyikan kata sandi'
                ,
                  "aria-pressed": !_ctx.isShowPassword,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
                  onKeydown: [
                    _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args)), ["enter"])),
                    _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args)), ["prevent"]), ["space"]))
                  ]
                }, [
                  _createVNode(_component_FontAwesomeIcon, {
                    icon: _ctx.isShowPassword ? 'eye' : 'eye-slash',
                    "aria-hidden": "true"
                  }, null, 8, ["icon"])
                ], 40, _hoisted_9)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_BFormInput, {
              modelValue: _ctx.formData.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.password) = $event)),
              state: _ctx.v$.password.$errors.length === 0 ? null : false,
              type: _ctx.isShowPassword ? 'password' : 'text',
              class: _normalizeClass(`placeholder-placeholder-gc ${
              _ctx.v$.password.$errors.length === 0 ? 'border-r-0' : ''
            }`),
              id: "password",
              placeholder: "Masukkan kata sandi anda",
              required: "",
              autocomplete: "current-password",
              "aria-describedby": "password-errors password-help password-visibility-toggle",
              "aria-invalid": _ctx.v$.password.$errors.length > 0,
              onInput: _ctx.v$.password.$touch,
              onKeydown: _withKeys(_ctx.handleEnterKey, ["enter"])
            }, null, 8, ["modelValue", "state", "type", "class", "aria-invalid", "onInput", "onKeydown"])
          ]),
          _: 1
        }),
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.$errors, (error) => {
          return (_openBlock(), _createElementBlock("div", {
            id: "password-errors",
            class: "input-errors",
            role: "alert",
            "aria-live": "polite",
            key: error.$uid
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(error.$message), 1)
          ]))
        }), 128))
      ]),
      _createVNode(_component_BButton, {
        type: "submit",
        variant: "warning",
        class: "w-full text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-primary-gc focus:ring-offset-2",
        disabled: _ctx.isLoading,
        "aria-label": 
          _ctx.isLoading ? 'Sedang memproses login...' : 'Masuk ke akun Anda'
        ,
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Sedang memproses..."))
            : _createCommentVNode("", true),
          _createTextVNode(" Masuk ")
        ]),
        _: 1
      }, 8, ["disabled", "aria-label", "onClick"])
    ], 32)
  ]))
}